"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalTopSpacing = exports.modalStaticClassName = exports.modalResponsiveClassName = exports.modalResponsive = exports.modalOverlayStaticClassName = exports.modalOverlayResponsiveClassName = exports.modalOverlayResponsive = exports.modalFooterStaticClassName = exports.modalFooterDefault = exports.modalFooterClassName = exports.modalDialogResponsiveClassName = exports.modalDialogClassName = exports.modalDefaultClassName = exports.modalDefault = exports.devices = void 0;
require("./modalStyles.css");
var _zIndex = require("@cbhq/cds-common/tokens/zIndex");
var _breakpoints = require("../../layout/breakpoints");
var _tokens = require("../../tokens");
var _linaria = require("../../utils/linaria");
const devices = {
  phone: _breakpoints.deviceMqs.phone,
  tablet: _breakpoints.deviceMqs.tablet
};
exports.devices = devices;
const modalTopSpacing = _tokens.spacing[10];
exports.modalTopSpacing = modalTopSpacing;
const modalStaticClassName = 'cds-modal';
exports.modalStaticClassName = modalStaticClassName;
const modalOverlayStaticClassName = 'cds-modal-overlay';
exports.modalOverlayStaticClassName = modalOverlayStaticClassName;
const modalFooterStaticClassName = 'cds-modal-footer';

/** Modal styles */
exports.modalFooterStaticClassName = modalFooterStaticClassName;
const modalDefault = "cds-modalDefault-m1hij5we";
exports.modalDefault = modalDefault;
const modalResponsive = "cds-modalResponsive-mjlcy9u";
exports.modalResponsive = modalResponsive;
const modalDialogClassName = "cds-modalDialogClassName-mejubxv";
exports.modalDialogClassName = modalDialogClassName;
const modalDialogResponsiveClassName = "cds-modalDialogResponsiveClassName-my6zx03";
exports.modalDialogResponsiveClassName = modalDialogResponsiveClassName;
const modalDefaultClassName = (0, _linaria.cx)(modalStaticClassName, modalDefault);
exports.modalDefaultClassName = modalDefaultClassName;
const modalResponsiveClassName = (0, _linaria.cx)(modalStaticClassName, modalResponsive);

/** Overlay styles */
exports.modalResponsiveClassName = modalResponsiveClassName;
const modalOverlayResponsive = "cds-modalOverlayResponsive-m1dk4hko";
exports.modalOverlayResponsive = modalOverlayResponsive;
const modalOverlayResponsiveClassName = (0, _linaria.cx)(modalOverlayStaticClassName, modalOverlayResponsive);

/** Footer actions layout */
exports.modalOverlayResponsiveClassName = modalOverlayResponsiveClassName;
const stacked = {
  '& > button, a': {
    flex: 'none'
  },
  'flex-direction': 'column-reverse',
  /* Set height for vertical Spacer */
  'span:nth-child(2)': {
    height: _tokens.spacing[2]
  }
};
const block = {
  '& > button, a': {
    flex: 1
  }
};
const modalFooterDefault = "cds-modalFooterDefault-m7kt8hz";
exports.modalFooterDefault = modalFooterDefault;
const modalFooterClassName = (0, _linaria.cx)(modalFooterStaticClassName, modalFooterDefault);
exports.modalFooterClassName = modalFooterClassName;